import { FileTextOutlined } from '@ant-design/icons';
import type { NavigationItemType } from '~/types/navigation';

export default {
    id: 'receiving-lists',
    title: 'Liste za zaprimanje',
    icon: FileTextOutlined,
    type: 'item',
    url: '/receiving-lists',
} satisfies NavigationItemType;
